import { useState } from "react";

import { SearchBar } from "@/components/search-bar";
import { useDebounce } from "@/hooks/useDebounce";
import { cn } from "@/utils/cn";

import type { BrandRequestFilterId } from "./config/filterConfig";

import { BrandRequestsFilterDropdown } from "./BrandRequestsFilterDropdown";
import { BrandRequestsTable } from "./BrandRequestsTable";
import { DEFAULT_BRAND_REQUEST_FILTER } from "./config/filterConfig";

interface BrandRequestsLayoutProps {
  brandId: number;
  /**
   * When true (default), the table breaks out of the page's horizontal
   * padding for a full-bleed look. Set to false when embedding inside a
   * padded container (e.g. the brand-details tab) to avoid overflow.
   */
  fullBleed?: boolean;
}

export function BrandRequestsLayout({
  brandId,
  fullBleed = true,
}: BrandRequestsLayoutProps) {
  const [filter, setFilter] = useState<BrandRequestFilterId>(
    DEFAULT_BRAND_REQUEST_FILTER,
  );
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 400);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col-reverse gap-3 sm:flex-row sm:items-center sm:gap-4">
        <BrandRequestsFilterDropdown
          onFilterChange={(newFilter) => {
            setFilter(newFilter);
            setSearch("");
          }}
          selectedFilter={filter}
        />
        <SearchBar
          className="flex-1"
          inputValue={search}
          setInputValue={setSearch}
        />
      </div>
      <div className={cn(fullBleed && "-mx-lg sm:-mx-3xl")}>
        <BrandRequestsTable
          brandId={brandId}
          debouncedSearch={debouncedSearch}
          filter={filter}
          key={filter}
        />
      </div>
    </div>
  );
}
